// src/Redux/selectors/healthBotSelectors.js
export const selectHBToken = (s) => s.healthBot.token;
export const selectHBExpiresAt = (s) => s.healthBot.expiresAt;
export const selectHBStatus = (s) => s.healthBot.status;
export const selectHBError = (s) => s.healthBot.error;

export const selectHBDlEndpoint = (s) => s.healthBot.directLineEndpoint;
export const selectHBUserId = (s) => s.healthBot.userId;
export const selectHBLastReissuedAt = (s) => s.healthBot.lastReissuedAt;